import BenefitStyle from '@/styles/pages/career/customize-career-page/_index.module.scss';
import {EditBannerIcon, useRef} from '@/imports-files/pages/career/customize-career-page';
import BenefitEditIcon from 'public/images/pages/career/benefit/icons/benefit_editIcon.svg';
import BlackCloseIcon from 'public/images/pages/career/benefit/icons/black_close.svg';
import AddMemberIcon from 'public/icons/career_icons/add-plus.svg';
import { isMobile, TabletView } from 'react-device-detect';
import parse from 'html-react-parser';
import { useState, useEffect } from '@/imports-files/common/common';

// Import Swiper React components
import { Swiper, SwiperSlide } from "swiper/react";

// Import Swiper styles
import "swiper/css";
import "swiper/css/free-mode";
import "swiper/css/pagination";

// import required modules
import { FreeMode, Autoplay, Mousewheel } from "swiper"


export function Benefit({formik, index, page_section, customizeCareerAction, isPreview, resetCareerPage}){
  const benefitSection = useRef(formik.values.page_sections_attributes[index].career_benefit_section_attributes)
  const validItemLength = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter((x) => isPreview ? x.display == "show" : true).length
  const [flagForRender, setFlagForRender] = useState(0);
  const [flagForReRender, setFlagForReRender] = useState(0);
  const [addDisabled, setAddDisabled] = useState(false);
  const headingFontColor = customizeCareerAction.job_benefit_heading_color(formik)
  function benefitCount(formik, index) {
    let count = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length

    if(TabletView && !isMobile){
      return count <= 3 ? 'swiper-center tablet' : ''
    }
    else if(isMobile){
      return count <= 2 ? 'swiper-center mobile' : ''
    }
    else {
      return count <= 3 ? 'swiper-center' : ''
    }
  }

  function cardLayout(formik, index){
    let item_length =  formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter((x) => isPreview ? x.display == "show" : true).length
    if(typeof window !== 'undefined' && window.innerWidth >=768 && window.innerWidth <=1024){
      return BenefitStyle.Benefit__FourCardLayout
    }
    switch(true){
    case (item_length < 3):
      return BenefitStyle.Benefit__FourCardLayout
    case (item_length == 3):
      return BenefitStyle.Benefit__ThreeCardLayout
    case (item_length == 4):
      return BenefitStyle.Benefit__FourCardLayout
    case (item_length <= 6):
      return BenefitStyle.Benefit__SixCardLayout
    default:
      return BenefitStyle.Benefit__SixCardLayout
    }
  }

  function benefitDefaultImage(record, benefit_index){
    if(record.image_url){
      return record.image_url
    }
    else {
      return '/images/pages/career/benefit/dummy-icon.svg'
      // if(benefit_index > 2 || (record.display == 'hide'))
      // switch(benefit_index){
      // case 0:
      //   return '/images/pages/career/benefit/icons/fire--alarm.png'
      // case 1:
      //   return '/images/pages/career/benefit/icons/apple.png'
      // case 2:
      //   return '/images/pages/career/benefit/icons/rock-on.png'
      // }
    }
  }

  function getTitleDescription(benefitSection, benefit_index, type){
    switch(type){
    case 'title':
      return benefitSection.current.career_benefit_details_attributes.filter((x)=> !x.destroy)[benefit_index].title || ''
    case 'description':
      return benefitSection.current.career_benefit_details_attributes.filter((x)=> !x.destroy)[benefit_index].description || ''
    }
  }

  useEffect(() => {
    benefitSection.current.career_benefit_details_attributes = formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.filter((x)=> !x.destroy)
    benefitSection.current.title = formik.values.page_sections_attributes[index].career_benefit_section_attributes.title
    setFlagForReRender(Math.random()*10000)
  }, [flagForRender, resetCareerPage])

  if(validItemLength == 0 && isPreview) return null
  return(
    <div className = {`${BenefitStyle.Benefit}`} id={page_section.uniq_reference}>
      <div className = {isPreview ? `${BenefitStyle.Benefit__PreviewContainer}`: `${BenefitStyle.Benefit__Container}`}>
      {/************* First Option ***************/}

      <div className = {`${BenefitStyle.Benefit__FirstOption}`}>
        <div className = {`${BenefitStyle.Benefit__Content}`}>
          <div className = {`${ isPreview ? BenefitStyle.Benefit__ContentPreview : BenefitStyle.Benefit__ContentEditable }`}>
            <div className = {`${BenefitStyle.Benefit__SubTitle}`}>
              {isPreview ? <div
                suppressContentEditableWarning={true}
                style={headingFontColor}
              >{parse(benefitSection.current.title)}</div>
              :
              <div
                contentEditable={true}
                onInput={(e)=> {
                  customizeCareerAction.titleLengthWarning(e.currentTarget.textContent)
                  formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.title`, e.currentTarget.innerHTML)
                }}
                onPaste={(event)=> {
                  customizeCareerAction.onPastePreventStyling(event)
                }}
                onBlur={(e)=>  {
                  customizeCareerAction.updateAboutSection(formik, index)
                }}
                suppressContentEditableWarning={true}
                dangerouslySetInnerHTML={{ __html: benefitSection.current.title }}
                style={headingFontColor}
                />
              }
            </div>
          </div>

          {!isPreview && <div className = {`${BenefitStyle.Benefit__Cards} ${cardLayout(formik, index)}`}>
            {formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.map((benefit_detail, benefit_index) => {
              return (
                <div className = {`${BenefitStyle.Benefit__Card} ${BenefitStyle.Benefit__Card__Hover}`} key={`benefit_section_f_${benefit_detail.id || benefit_index}`}>
                  {!isPreview && (formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length > 2) && <div className = {`${BenefitStyle.Benefit__Card__Delete}`}>
                    <BlackCloseIcon onClick={()=> {
                      customizeCareerAction.removeBenefitCard(formik, index, benefit_index, setFlagForRender)
                    }} />
                  </div>}
                  <div className = {`${BenefitStyle.Benefit__Card__Icon}`}>
                    <img src = {benefitDefaultImage(benefit_detail, benefit_index)}></img>
                    {!isPreview && <div className = {`${BenefitStyle.Benefit__Card__EditIcon}`}>
                      <input type="file" id="img" name="img"
                        accept    =   ".png, .jpg, .jpeg"
                        onChange   =   { (event) => customizeCareerAction.handleBenefitImage(event, formik, index, benefit_index)}
                        title = { customizeCareerAction.imageInfoContent('benefit_image')}
                       />
                    </div>}
                  </div>
                  <div className = {`${ isPreview ? BenefitStyle.Benefit__ContentPreview : BenefitStyle.Benefit__ContentEditable }`}>
                    <div className = {`${BenefitStyle.Benefit__Card__Title}`}>
                      {isPreview ? <div
                        suppressContentEditableWarning={true}
                        dangerouslySetInnerHTML={{ __html: benefitSection.current.career_benefit_details_attributes[benefit_index].title }}
                        style={headingFontColor}
                      />
                      :
                      <div className = {`${formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index]?.display=='show'  ? '' : BenefitStyle.Benefit__AddDescriptionText}`}
                        contentEditable={true}
                        onInput={(e)=> {
                          formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.career_benefit_details_attributes.${benefit_index}.display`, "show")
                          formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.career_benefit_details_attributes.${benefit_index}.title`, e.currentTarget.innerHTML)
                        }}
                        onPaste={(event)=> {
                          customizeCareerAction.onPastePreventStyling(event)
                        }}
                        onFocus={(e)=>  {
                          const placeholder = e.currentTarget.getAttribute('data-placeholder');
                          const value = e.currentTarget.innerHTML;
                          value === placeholder && (e.currentTarget.innerHTML = '');
                        }}
                        onBlur={(e)=>  {
                          const placeholder = e.currentTarget.getAttribute('data-placeholder');
                          const value = e.currentTarget.innerHTML;
                          value === '' && (e.currentTarget.innerHTML = placeholder);
                          customizeCareerAction.updateAboutSection(formik, index)
                        }}
                        data-placeholder={'Add title'}
                        suppressContentEditableWarning={true}
                        dangerouslySetInnerHTML={{ __html: benefitSection.current.career_benefit_details_attributes[benefit_index]?.title || '' }}
                        style={headingFontColor}
                      />
                      }
                    </div>
                  </div>
                  <div className = {`${ isPreview ? BenefitStyle.Benefit__ContentPreview : BenefitStyle.Benefit__ContentEditable }`}>
                    <div className = {`${BenefitStyle.Benefit__Card__Text}`}>
                      {isPreview ? <div
                        suppressContentEditableWarning={true}
                        dangerouslySetInnerHTML={{ __html: benefitSection.current.career_benefit_details_attributes[benefit_index].description }}
                        style={headingFontColor}
                      />
                      :
                      <div className = {`${formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes[benefit_index]?.display=='show' ? '' : BenefitStyle.Benefit__AddDescriptionText}`}
                        contentEditable={true}
                        onInput={(e)=> {
                          formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.career_benefit_details_attributes.${benefit_index}.display`, "show")
                          formik.setFieldValue(`page_sections_attributes.${index}.career_benefit_section_attributes.career_benefit_details_attributes.${benefit_index}.description`, e.currentTarget.innerHTML)
                        }}
                        onPaste={(event)=> {
                          customizeCareerAction.onPastePreventStyling(event)
                        }}
                        onFocus={(e)=>  {
                          const placeholder = e.currentTarget.getAttribute('data-placeholder');
                          const value = e.currentTarget.innerHTML;
                          value === placeholder && (e.currentTarget.innerHTML = '');
                        }}
                        onBlur={(e)=>  {
                          const placeholder = e.currentTarget.getAttribute('data-placeholder');
                          const value = e.currentTarget.innerHTML;
                          value === '' && (e.currentTarget.innerHTML = placeholder);
                          customizeCareerAction.updateAboutSection(formik, index)
                        }}
                        data-placeholder={'Add description'}
                        suppressContentEditableWarning={true}
                        dangerouslySetInnerHTML={{ __html: benefitSection.current.career_benefit_details_attributes[benefit_index]?.description }}
                        style={headingFontColor}
                        max={500}
                      />
                      }
                    </div>
                  </div>
                </div>
              )
            })}
          </div>}

          {/************** First Option Preview **************/}
          {isPreview && <div className = {`${BenefitStyle.Benefit__Preview}`}>

              <div className = {`${BenefitStyle.Benefit__Cards} ${cardLayout(formik, index)} ${benefitCount(formik, index)}`}>
                {formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.map((benefit_detail, benefit_index) => {
                  return (
                          benefit_detail.display == 'show' && <div className = {`${BenefitStyle.Benefit__Card}`}>
                            <div className = {`${BenefitStyle.Benefit__Card__Icon}`}>
                              <img src = {benefitDefaultImage(benefit_detail, benefit_index)}></img>
                            </div>
                            <div className = {`${BenefitStyle.Benefit__ContentPreview}`}>
                              <div className = {`${BenefitStyle.Benefit__Card__Title}`}>
                                <div style={headingFontColor}>{parse(benefit_detail.title)}</div>
                              </div>
                              <div className = {`${BenefitStyle.Benefit__Card__Text}`}>
                                <div style={headingFontColor}>{parse(benefit_detail.description)}</div>
                              </div>
                            </div>
                          </div>
                    )
                  })
                }
              </div>
            </div>
          }
        </div>
        {!isPreview && (formik.values.page_sections_attributes[index].career_benefit_section_attributes.career_benefit_details_attributes.length < 6) && <div className = {`${BenefitStyle.MeetTeam__AddNewMember}`}
            onClick={async(event) => {
              if(!addDisabled)
              {
                setAddDisabled(true)
                await customizeCareerAction.addBenefitCard(formik, index, setFlagForRender)
                setAddDisabled(false)
              }
            }}
          >
            <span style={headingFontColor}> <span className = {`${BenefitStyle.MeetTeam__AddNewMember__Icon}`}><AddMemberIcon /></span> Add Value </span>
        </div>}

      </div>

      {/* {!isPreview && <div className = {`${BenefitStyle.Benefit__RemoveSection}`}> */}
      {/*     <span onClick={(event) => { */}
      {/*       customizeCareerAction.removeSection(formik, page_section) */}
      {/*     }}><img src ='/icons/career_icons/delete.svg'></img></span> */}
      {/*   </div> */}
      {/* } */}
      </div>
    </div>
  )
}

